module.exports = __webpack_public_path__ + "static/img/checkbox.6ac952ff.jpg";